import { render } from "./emailLogs.vue?vue&type=template&id=322ae574&ts=true"
import script from "./emailLogs.vue?vue&type=script&lang=ts"
export * from "./emailLogs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__